import Layout from './Layout';
import {
  Divider,
  Skeleton,
  PortfolioContainer,
  Table,
  TableRow,
  TableCell,
  ThickDivider,
  BorderedButton,
} from './styled';
import { Flex } from '../Flex';

const SkeletonHeader = () => (
  <Flex px={16} py={12}>
    <Skeleton width={120} height={30} />
  </Flex>
);
const LeftSection = () => (
  <Flex direction="column" height="100%" px={16} py={12} gap={14}>
    <Skeleton width={106} height={30} />

    <Flex
      direction="column"
      gap={14}
      position="relative"
      height="100%"
      style={{ overflow: 'auto' }}
    >
      <Flex direction="column" gap={14} position="absolute" width="100%">
        <PortfolioContainer>
          <Flex>
            {new Array(3).fill('').map((_, i) => (
              <Flex key={i.toString()} direction="column" gap={6} width="100%">
                <Skeleton width={120} height={12} />
                <Skeleton width={80} height={12} />
              </Flex>
            ))}
          </Flex>

          <Divider />

          <Flex align="center" gap={12} height={28} mb={40}>
            <Skeleton width={80} height={12} />
            <Skeleton variant="outline" width={148} height="100%" />

            <Flex gap={8}>
              {new Array(3).fill('').map((_, i) => (
                <Skeleton
                  key={i.toString()}
                  variant="outline"
                  width={80}
                  height={28}
                  rounded
                />
              ))}
            </Flex>
          </Flex>
        </PortfolioContainer>

        <Table>
          {new Array(21).fill('').map((_, rowIdx) => (
            <TableRow key={rowIdx.toString()}>
              {new Array(5).fill('').map((_, colIdx) => (
                <TableCell key={`${rowIdx.toString()}-${colIdx.toString()}`}>
                  <Flex height={16} />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </Table>
      </Flex>
    </Flex>

    <Flex gap={16}>
      <Skeleton variant="outline" width="100%" height={32} />
      <Skeleton variant="outline" width="100%" height={32} />
    </Flex>
  </Flex>
);

const RightSection = () => (
  <Flex direction="column" width="100%" height="100%">
    <Flex direction="column" px={16} py={12} mb={22} gap={12}>
      {Array.from({ length: 3 }).map((_, idx) => (
        <Flex
          key={`ohlc-${idx.toString()}`}
          width="100%"
          justify="space-between"
          gap={30}
        >
          <Flex width="100%" justify="space-between">
            <Skeleton width={40} height={12} />
            <Skeleton width={60} height={12} />
          </Flex>
          <Flex width="100%" justify="space-between">
            <Skeleton width={40} height={12} />
            <Skeleton width={60} height={12} />
          </Flex>
        </Flex>
      ))}
    </Flex>
    <ThickDivider />
    <Flex direction="column" width="100%" py={12} gap={12}>
      <Flex width="100%" justify="flex-end" gap={8} px={16}>
        <BorderedButton />
        <BorderedButton />
      </Flex>

      <Flex direction="column" px={8}>
        <Divider />
        <Flex width="100%" justify="space-between">
          {Array.from({ length: 5 }).map((_, idx) => (
            <Flex key={`th-${idx.toString()}`} px={8} py={10}>
              <Skeleton width={40} height={12} />
            </Flex>
          ))}
        </Flex>
        <Divider />
        <Flex direction="column" gap={10} py={10}>
          {Array.from({ length: 4 }).map(() => (
            <Skeleton width="100%" height={12} />
          ))}
        </Flex>
      </Flex>
    </Flex>
  </Flex>
);

const FastOrderSkeleton = () => (
  <Layout
    header={<SkeletonHeader />}
    leftSection={<LeftSection />}
    rightSection={<RightSection />}
  />
);

export default FastOrderSkeleton;
